(function() {
  window.unlockQueueService = {
    getQueue() {
      return axios.get('/api/unlock/get.php?queue=true');
    },
    getReceived() {
      return axios.get('/api/unlock/get.php?received=true');
    },
    getActive() {
      return axios.get('/api/unlock/get.php?active=true');
    },
    getAuto() {
      return axios.get('/api/unlock/get.php?auto=true');
    },
    save(data) {
      return axios.post('/api/unlock/save.php', data)
    },
    cancel(data) {
      return axios.post('/api/unlock/cancel.php', data);
    }
  }
})();